const GIFS = [{
    row : '9',
    label : 'VIP Exclusive',
    gifs : ['throw-money','wot','bitchin','deal','kick', 'no-fool','rad','rich-famous']
}
];
export default GIFS;